{
  "version": 1,
  "asset_id": "bcec3d8b-22a5-40c2-b19b-f95676c0987b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/bcec3d8b-22a5-40c2-b19b-f95676c0987b/gastric-bypass-es-v2-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/bcec3d8b-22a5-40c2-b19b-f95676c0987b/gastric-bypass-es-v2-800.webp",
  "original_filename": "gastric-bypass-es-v2-800.webp",
  "size": 43864,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:00:47Z"
}
